import { render, staticRenderFns } from "./post.vue?vue&type=template&id=4fb82ca4&scoped=true"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"
import style0 from "./post.vue?vue&type=style&index=0&id=4fb82ca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb82ca4",
  null
  
)

export default component.exports